"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.factsOptions = void 0;
const factsOptions = exports.factsOptions = {
  acOptions: [{
    label: 'Yes',
    value: true,
    id: 'acOptions.yes'
  }, {
    label: 'No',
    value: false,
    id: 'acOptions.no'
  }],
  amentitiesQuality: [{
    label: 'Out to date',
    value: 5,
    active: false
  }, {
    label: 'Fair',
    value: 4,
    active: false
  }, {
    label: 'Good',
    value: 3,
    active: false
  }, {
    label: 'Very Good',
    value: 2,
    active: false
  }, {
    label: 'Exceptional',
    value: 1,
    active: false
  }],
  apartmentQuality: [{
    label: 'Poor',
    value: 4,
    active: false
  }, {
    label: 'Fair',
    value: 3,
    active: false
  }, {
    label: 'Good',
    value: 2,
    active: false
  }, {
    label: 'Exceptional',
    value: 1,
    active: false
  }],
  availability: [{
    label: 'On Agreement',
    value: 'on-agreement',
    id: 'availability.agreement'
  }, {
    label: 'Immediately',
    value: 'immediately',
    id: 'availability.immediately'
  }, {
    label: 'Other',
    value: 'other',
    id: 'availability.other'
  }],
  basementOptions: [{
    label: 'Yes',
    value: true,
    id: 'basementOptions.yes'
  }, {
    label: 'No',
    value: false,
    id: 'basementOptions.no'
  }],
  buyerKnowledge: [{
    label: 'I want to buy for the first time',
    value: 'first-time-buyer'
  }, {
    label: 'I already bought once a property',
    value: 'bought-one-property'
  }, {
    label: 'I bought more than one property',
    value: 'bought-more-than-one-property'
  }],
  buyerLivingSituation: [{
    label: 'I own my current property',
    value: 'owner-property'
  }, {
    label: 'I am renting a property',
    value: 'tenant-property'
  }],
  buyerFamilySituation: [{
    label: 'Single household',
    value: 'single'
  }, {
    label: 'Couple',
    value: 'couple'
  }, {
    label: 'Family with kids',
    value: 'family'
  }, {
    label: 'Investor',
    value: 'investor'
  }, {
    label: 'Other',
    value: 'other'
  }],
  conditionCode: [{
    label: 'Poor',
    value: 4,
    active: false
  }, {
    label: 'Fair',
    value: 3,
    active: false
  }, {
    label: 'Good',
    value: 2,
    active: false
  }, {
    label: 'Exceptional',
    value: 1,
    active: false
  }],
  constructionMaterials: [{
    label: 'Wood',
    value: 'wood',
    id: 'constructionMaterials.wood'
  }, {
    label: 'Cement',
    value: 'cement',
    id: 'constructionMaterials.aluminium'
  }, {
    label: 'Brick',
    value: 'brick',
    id: 'constructionMaterials.synthetics'
  }],
  constructedVolumeCode: [{
    label: 'Building insurance',
    value: 1
  }, {
    label: 'SIA 116',
    value: 2
  }, {
    label: 'SIA 416',
    value: 4
  }, {
    label: 'Other',
    value: 3
  }],
  currency: [{
    label: 'CHF',
    value: 'CHF'
  }, {
    label: 'EUR',
    value: 'EUR'
  }, {
    label: 'GBP',
    value: 'GBP'
  }, {
    label: 'USD',
    value: 'USD'
  }],
  custormerSatisfaction: [{
    label: 'Very bad',
    value: 1,
    active: false
  }, {
    label: 'Poor',
    value: 2,
    active: false
  }, {
    label: 'Average',
    value: 3,
    active: false
  }, {
    label: 'Good',
    value: 4,
    active: false
  }, {
    label: 'Excellent',
    value: 5,
    active: false
  }],
  dealsStatus: [{
    label: 'All deals',
    value: 'all',
    id: 'dealsStatus.all'
  }, {
    label: 'New deals',
    value: 'new',
    id: 'dealsStatus.new'
  }, {
    label: 'Archived deals',
    value: 'archived',
    id: 'dealsStatus.archived'
  }],
  dealsStatusHub: [{
    label: 'All deals',
    value: 'all',
    id: 'dealsStatus.all'
  }, {
    label: 'New deals',
    value: 'newSeller',
    id: 'dealsStatus.newSeller'
  }, {
    label: 'Archived deals',
    value: 'archived',
    id: 'dealsStatus.archived'
  }],
  energyEfficiencyOptions: [{
    label: 'A+',
    value: 'A+',
    bgClass: 'bgGreen700'
  }, {
    label: 'A',
    value: 'A',
    bgClass: 'bgGreen600'
  }, {
    label: 'B',
    value: 'B',
    bgClass: 'bgGreen500'
  }, {
    label: 'B-',
    value: 'B-',
    bgClass: 'bgGreen400'
  }, {
    label: 'C',
    value: 'C',
    bgClass: 'bgGreen200'
  }, {
    label: 'D',
    value: 'D',
    bgClass: 'bgYellow200'
  }, {
    label: 'E',
    value: 'E',
    bgClass: 'bgYellow400'
  }, {
    label: 'F',
    value: 'F',
    bgClass: 'bgYellow500'
  }, {
    label: 'G',
    value: 'G',
    bgClass: 'bgRed400'
  }],
  energyEfficiencyCertified: [{
    label: 'Yes',
    value: 'yes',
    id: 'energyEfficiencyCertified.yes'
  }, {
    label: 'Pending',
    value: 'pending',
    id: 'energyEfficiencyCertified.pending'
  }, {
    label: 'Not available',
    value: 'not-available',
    id: 'energyEfficiencyCertified.not-available'
  }, {
    label: 'Not applicable',
    value: 'not-applicable',
    id: 'energyEfficiencyCertified.not-applicable'
  }],
  energyPerformanceCertified: [{
    label: 'Demand certificate',
    value: 'demandCerificate',
    id: 'energyPerformanceCertified.demandCerificate'
  }, {
    label: 'Consumption pass',
    value: 'consumptionPass',
    id: 'energyPerformanceCertified.consumptionPass'
  }, {
    label: 'Not available',
    value: 'notAvailable',
    id: 'energyPerformanceCertified.notAvailable'
  }],
  expandableAttic: [{
    label: 'Yes',
    value: 1
  }, {
    label: 'No',
    value: 0
  }, {
    label: 'Already expanded',
    value: 2
  }],
  extraFeature: [{
    label: 'Steam oven',
    value: 'steamOven',
    id: 'cl_steamOven',
    icon: 'steam-oven'
  }, {
    label: 'Own Washing Machine',
    value: 'washingMachine',
    id: 'cl_washingMachine',
    icon: 'washing-machine'
  }, {
    label: 'Equipped Kitchen',
    value: 'equippedKitchen',
    id: 'cl_equippedKitchen',
    icon: 'kitchen'
  }, {
    label: 'Tumbler',
    value: 'tumbler',
    id: 'cl_tumbler',
    icon: 'tumbler'
  }, {
    label: 'High-end equipment',
    value: 'highEndEquipment',
    id: 'cl_highEndEquipment',
    icon: 'highend-equipment'
  }, {
    label: 'Fireplace',
    value: 'fireplace',
    id: 'cl_fireplace',
    icon: 'fireplace'
  }, {
    label: 'Exceptional room sizes',
    value: 'Exceptional room size',
    id: 'cl_roomSize',
    icon: 'exceptional-room-size'
  }, {
    label: 'First-time occupancy',
    value: 'firstTimeOccupancy',
    id: 'cl_firstTime',
    icon: 'first-time-occupancy'
  }, {
    label: 'Old building',
    value: 'oldBuilding',
    id: 'cl_oldBuilding',
    icon: 'old-building'
  }, {
    label: 'Playground',
    value: 'playground',
    id: 'cl_playground',
    icon: 'playground'
  }, {
    label: 'Child friendly',
    value: 'childFriendly',
    id: 'cl_childFriendly',
    icon: 'child-friendly'
  }, {
    label: 'Wheelchair Accessible',
    value: 'wheelchair',
    id: 'cl_wheelchair',
    icon: 'wheel-chair'
  }, {
    label: 'Lift',
    value: 'elevator',
    id: 'cl_elevator',
    icon: 'elevator'
  }, {
    label: 'Wardrobe',
    value: 'wardrobe',
    id: 'cl_wardrobe',
    icon: 'wardrobe'
  }, {
    label: 'Suite',
    value: 'suite',
    id: 'cl_suite',
    icon: 'suite'
  }, {
    label: 'Alarm',
    value: 'alarm',
    id: 'cl_alarm',
    icon: 'alarm'
  }, {
    label: 'Video Security',
    value: 'videoSecurity',
    id: 'cl_videoSecurity',
    icon: 'video-security'
  }, {
    label: 'Gym',
    value: 'gym',
    id: 'cl_gym',
    icon: 'gym'
  }, {
    label: 'Landscape',
    value: 'landscape',
    id: 'cl_landscape',
    icon: 'landscape'
  }, {
    label: 'High quality materials',
    value: 'High quality materials',
    id: 'cl_highQuality',
    icon: 'highquality-materials'
  }, {
    label: 'Renowned architecture',
    value: 'renownedArchitecture',
    id: 'cl_renownedArchitecture',
    icon: 'renowned-architecture'
  }, {
    label: 'Minergie certified',
    value: 'minergieCertified',
    id: 'cl_minergie',
    icon: 'minergie-certified'
  }, {
    label: 'Sauna',
    value: 'sauna',
    id: 'cl_sauna',
    icon: 'sauna'
  }, {
    label: 'Swimming Pool',
    value: 'swimmingPool',
    id: 'cl_swimmingPool',
    icon: 'swimming-pool'
  }, {
    label: 'Tennis Court',
    value: 'Tennis Court',
    id: 'cl_tennis',
    icon: 'tennis-court'
  }, {
    label: 'Water Access',
    value: 'waterAccess',
    id: 'cl_waterAccess',
    icon: 'water-access'
  }],
  extraFeatureShort: [{
    label: 'First-time occupancy',
    value: 'firstTimeOccupancy',
    id: 'cl_firstTime',
    icon: 'first-time-occupancy'
  }, {
    label: 'Parking',
    value: 'parking',
    id: 'cl_parking',
    icon: 'parking'
  }, {
    label: 'Old building',
    value: 'oldBuilding',
    id: 'cl_oldBuilding',
    icon: 'old-building'
  }, {
    label: 'Fireplace',
    value: 'fireplace',
    id: 'cl_fireplace',
    icon: 'fireplace'
  }, {
    label: 'Lift',
    value: 'elevator',
    id: 'cl_elevator',
    icon: 'elevator'
  }, {
    label: 'Balcony',
    value: 'balcony',
    id: 'cl_balcony',
    icon: 'balcony'
  }, {
    label: 'Wheelchair Accessible',
    value: 'wheelchair',
    id: 'cl_wheelchair',
    icon: 'wheel-chair'
  }, {
    label: 'Garden',
    value: 'garden',
    id: 'cl_garden',
    icon: 'garden'
  }],
  facade: [{
    label: 'Plastered',
    value: 'plastered',
    id: 'facade.plastered'
  }, {
    label: 'Painted',
    value: 'painted',
    id: 'facade.painted'
  }, {
    label: 'Eternit cement',
    value: 'eternitCement',
    id: 'facade.eternitCement'
  }, {
    label: 'Natural wood',
    value: 'naturalWood',
    id: 'facade.naturalWood'
  }],
  heating: [{
    label: 'Oil',
    value: 'oil',
    id: 'heatingOptions.oil'
  }, {
    label: 'Gas',
    value: 'gas',
    id: 'heatingOptions.gas'
  }, {
    label: 'Wood',
    value: 'wood',
    id: 'heatingOptions.wood'
  }, {
    label: 'Solar',
    value: 'solar',
    id: 'heatingOptions.solar'
  }, {
    label: 'Electric',
    value: 'electric',
    id: 'heatingOptions.electric'
  }, {
    label: 'Heat pump',
    value: 'heatPump',
    id: 'heatingOptions.heatPump'
  }, {
    label: 'District heater',
    value: 'districtHeater',
    id: 'heatingOptions.districtHeater'
  }, {
    label: 'Combined heat and power plant',
    value: 'combinedHeatPowerPlant',
    id: 'heatingOptions.combinedHeatPowerPlant'
  }, {
    label: 'Geothermal probe',
    value: 'geothermalProbe',
    id: 'heatingOptions.geothermalProbe'
  }, {
    label: 'Pellet',
    value: 'pellet',
    id: 'heatingOptions.pellet'
  }, {
    label: 'Other',
    value: 'other',
    id: 'heatingOptions.other'
  }],
  heatingSystem: [{
    label: 'Stove heating',
    value: 'stoveHeating',
    id: 'heatingOptionsDE.stoveHeating'
  }, {
    label: 'Central heating',
    value: 'centralHeating',
    id: 'heatingOptionsDE.centralHeating'
  }, {
    label: 'Self-contained central heating',
    value: 'SelfContainedCentralHeating',
    id: 'heatingOptionsDE.SelfContainedCentralHeating'
  }, {
    label: 'Floor heating',
    value: 'floorHeating',
    id: 'heatingOptionsDE.floorHeating'
  }, {
    label: 'Radiator',
    value: 'radiator',
    id: 'heatingOptionsDE.radiator'
  }, {
    label: 'Other',
    value: 'other',
    id: 'heatingOptionsDE.other'
  }],
  isPropertyRenovatedOptions: [{
    label: 'Yes',
    value: 1
  }, {
    label: 'No',
    value: 0
  }],
  languages: [{
    label: 'English',
    value: 'en',
    id: 'english'
  }, {
    label: 'German',
    value: 'de',
    id: 'german'
  }],
  martialStatus: [{
    label: 'Single',
    value: 'single',
    id: 'martialStatus.single'
  }, {
    label: 'Married',
    value: 'married',
    id: 'martialStatus.married'
  }, {
    label: 'Divorced',
    value: 'divorced',
    id: 'martialStatus.divorced'
  }, {
    label: 'Widowed',
    value: 'widowed',
    id: 'martialStatus.widowed'
  }, {
    label: 'In a registered partnership',
    value: 'partnership',
    id: 'martialStatus.partnership'
  }],
  matrimonialPropertyRegime: [{
    label: 'Participation in acquired property',
    value: 'participation',
    id: 'matrimonialPropertyRegime.participation'
  }, {
    label: 'Community of property',
    value: 'community',
    id: 'matrimonialPropertyRegime.community'
  }, {
    label: 'Separation of property',
    value: 'separation',
    id: 'matrimonialPropertyRegime.separation'
  }],
  minergieCertifiedOptions: [{
    label: 'Yes',
    value: true,
    id: 'minergieCertifiedOptions.yes'
  }, {
    label: 'No',
    value: false,
    id: 'minergieCertifiedOptions.no'
  }],
  energyEfficiencyLabels: [{
    label: 'A',
    value: 'A'
  }, {
    label: 'B',
    value: 'B'
  }, {
    label: 'C',
    value: 'C'
  }, {
    label: 'D',
    value: 'D'
  }, {
    label: 'E',
    value: 'E'
  }, {
    label: 'F',
    value: 'F'
  }, {
    label: 'G',
    value: 'G'
  }],
  mortgage: [{
    label: 'Fixed',
    value: 'fixed'
  }, {
    label: 'Variable',
    value: 'variable'
  }, {
    label: 'No mortgage',
    value: 'no'
  }],
  multiStoreyApartmentOptions: [{
    label: 'Yes',
    value: 1
  }, {
    label: 'No',
    value: 0
  }],
  pageStatus: [{
    label: 'Published',
    value: 'published',
    id: 'pageStatus.published'
  }, {
    label: 'Market',
    value: 'market',
    id: 'pageStatus.market'
  }, {
    label: 'Portals',
    value: 'portals',
    id: 'pageStatus.portals'
  }],
  datesList: [{
    label: 'Today',
    value: 'today'
  }, {
    label: 'Past 7 days',
    value: 'week'
  }, {
    label: 'Past 30 days',
    value: 'month'
  }, {
    label: 'This year',
    value: 'year'
  }, {
    label: 'All',
    value: ''
  }],
  activityDatesList: [{
    label: 'Today',
    value: 'today'
  }, {
    label: 'Next 7 days',
    value: 'week'
  }, {
    label: 'This month',
    value: 'month'
  }, {
    label: 'This year',
    value: 'year'
  }, {
    label: 'All',
    value: ''
  }],
  activityStatus: [{
    label: 'All',
    value: '',
    id: 'activeStatus.all'
  }, {
    label: 'To do',
    value: false,
    id: 'activeStatus.toDo'
  }, {
    label: 'Done',
    value: true,
    id: 'activeStatus.done'
  }],
  purposeStatus: [{
    label: 'All',
    value: ''
  }, {
    label: 'Sell',
    value: 'seller'
  }, {
    label: 'Buy',
    value: 'buyer'
  }, {
    label: 'Estimation',
    value: 'inheritance'
  }, {
    label: 'Other',
    value: 'other'
  }],
  userStatus: [{
    label: 'All',
    value: '',
    id: 'ownerStatus.all'
  }, {
    label: 'Owner',
    value: 'seller',
    id: 'ownerStatus.seller'
  }, {
    label: 'Buyer',
    value: 'buyer',
    id: 'ownerStatus.buyer'
  }],
  progressBarOptions: [{
    label: 'Sales Lead',
    value: 'sales-lead'
  }, {
    label: 'Preparation',
    value: 'preparation'
  }, {
    label: 'Advertising',
    value: 'advertising'
  }, {
    label: 'Negotiation',
    value: 'negotiation'
  }, {
    label: 'Closing',
    value: 'closing'
  }],
  progressBarDealsOptions: [{
    label: 'Interested',
    value: 'Interested'
  }, {
    label: 'Visits',
    value: 'Visit'
  }, {
    label: 'Offers',
    value: 'Offer'
  }],
  propertyTypeAdmin: [{
    label: 'House',
    value: 'House',
    icon: 'property-house'
  }, {
    label: 'Apartment',
    value: 'Apartment',
    icon: 'property-apartment'
  }, {
    label: 'Commercial',
    value: 'Commercial',
    icon: 'property-commercial'
  }, {
    label: 'Building land',
    value: 'Building land',
    icon: 'property-building-land'
  }, {
    label: 'Multi-family building',
    value: 'Multi-family building',
    icon: 'property-house'
  }],
  propertyTypeNoIcon: [{
    label: 'House',
    value: 'House'
  }, {
    label: 'Apartment',
    value: 'Apartment'
  }, {
    label: 'Commercial',
    value: 'Commercial'
  }, {
    label: 'Building land',
    value: 'Building land'
  }, {
    label: 'Multi-family building',
    value: 'Multi-family building'
  }],
  propertyStatus: [{
    label: 'On sale',
    value: 'on-sale',
    id: 'status.sale'
  }, {
    label: 'Sold',
    value: 'sold',
    id: 'status.sold'
  }, {
    label: 'On request',
    value: 'on-request',
    id: 'status.request'
  }, {
    label: 'Reserved',
    value: 'reserved',
    id: 'status.reserved'
  }, {
    label: 'To rent',
    value: 'to-rent',
    id: 'status.rent'
  }],
  propertyStatusNoRent: [{
    label: 'On sale',
    value: 'on-sale',
    id: 'status.sale'
  }, {
    label: 'Sold',
    value: 'sold',
    id: 'status.sold'
  }, {
    label: 'On request',
    value: 'on-request',
    id: 'status.request'
  }, {
    label: 'Reserved',
    value: 'reserved',
    id: 'status.reserved'
  }],
  purchaseType: [{
    label: 'Sole ownership',
    value: 'sole',
    id: 'purchaseType.sole'
  }, {
    label: 'Joint ownership',
    value: 'joint',
    id: 'purchaseType.joint'
  }, {
    label: 'Co-ownership',
    value: 'co-ownership',
    id: 'purchaseType.co-ownership'
  }],
  quality: [{
    label: 'Poor',
    value: 4,
    active: false
  }, {
    label: 'Fair-Poor',
    value: 3.5,
    active: false
  }, {
    label: 'Fair',
    value: 3,
    active: false
  }, {
    label: 'Good-Fair',
    value: 2.5,
    active: false
  }, {
    label: 'Good',
    value: 2,
    active: false
  }, {
    label: 'Exceptional-Good',
    value: 1.5,
    active: false
  }, {
    label: 'Exceptional',
    value: 1,
    active: false
  }],
  qualityAssessor: [{
    label: 'Poor',
    value: 1,
    active: false
  }, {
    label: 'Fair',
    value: 2,
    active: false
  }, {
    label: 'Good',
    value: 3,
    active: false
  }, {
    label: 'Exceptional',
    value: 4,
    active: false
  }],
  qualityWithinBuilding: [{
    label: 'Poor',
    value: 4,
    active: false
  }, {
    label: 'Fair',
    value: 3,
    active: false
  }, {
    label: 'Good',
    value: 2,
    active: false
  }, {
    label: 'Exceptional',
    value: 1,
    active: false
  }],
  roofType: [{
    label: 'Flat roof',
    value: 'flat',
    id: 'roofType.flat'
  }, {
    label: 'Pitched roof',
    value: 'pitched',
    id: 'roofType.pitched'
  }],
  scanTrialFeedback: [{
    label: 'I don\'t want to sell this property.',
    value: 'no-sell-property',
    id: 'scanTrialFeedback.no-sell-property'
  }, {
    label: 'I already have high-quality photos.',
    value: 'has-image',
    id: 'scanTrialFeedback.have-image'
  }, {
    label: 'I already have a professional estimation.',
    value: 'has-professional-estimation',
    id: 'scanTrialFeedback.has-professional-estimation'
  }, {
    label: 'I am selling with an agent.',
    value: 'sell-with-agent',
    id: 'scanTrialFeedback.sell-with-agent'
  }],
  scanTrialInterest: [{
    label: 'Estimation',
    value: 'estimation',
    id: 'scanTrialInterest.estimation'
  }, {
    label: 'Scan of your property',
    value: 'scan-property',
    id: 'scanTrialInterest.scan-property'
  }],
  secondaryResidenceOptions: [{
    label: 'Yes',
    value: 1
  }, {
    label: 'No',
    value: 0
  }],
  solarOptions: [{
    label: 'Yes',
    value: true,
    id: 'solarOptions.yes'
  }, {
    label: 'No',
    value: false,
    id: 'solarOptions.no'
  }],
  solarOrientation: [{
    label: 'North',
    value: 'north',
    id: 'solarOrientation.yes'
  }, {
    label: 'South',
    value: 'south',
    id: 'solarOrientation.south'
  }, {
    label: 'East',
    value: 'east',
    id: 'solarOrientation.east'
  }, {
    label: 'West',
    value: 'west',
    id: 'solarOrientation.west'
  }],
  typeCommercialCode: [{
    label: 'Office',
    value: 1
  }, {
    label: 'Shop',
    value: 2
  }, {
    label: 'Commercial',
    value: 3
  }, {
    label: 'Storage room',
    value: 4
  }, {
    label: 'Practice',
    value: 5
  }, {
    label: 'Garage',
    value: 6
  }, {
    label: 'Factory',
    value: 7
  }, {
    label: 'Industrial object',
    value: 8
  }, {
    label: 'Hospital',
    value: 9
  }, {
    label: 'Nursing home',
    value: 10
  }, {
    label: 'Department store',
    value: 11
  }],
  typeFlatCode: [{
    label: 'Storey apartment',
    value: 1
  }, {
    label: 'Penthouse',
    value: 2
  }, {
    label: 'Attic apartment',
    value: 3
  }, {
    label: 'Ground floor Ap. w/ garden',
    value: 4
  }],
  typeFlatBuildingCode: [{
    label: 'Multi-family building',
    value: 1
  }, {
    label: 'Terraced slope',
    value: 2
  }],
  typeHouseCode: [{
    label: 'Individual house',
    value: 1
  }, {
    label: 'Semi-detached house',
    value: 2
  }, {
    label: 'Adjacent, in the middle',
    value: 3
  }, {
    label: 'Adjacent, in the corner',
    value: 4
  }, {
    label: 'In a terraced slope',
    value: 5
  }],
  userTypeEstimation: [{
    label: 'I\'m thinking about selling my property',
    value: 'seller'
  }, {
    label: 'It\'s related to an inheritance',
    value: 'inheritance'
  }],
  userType: [{
    label: 'I would like to sell my property',
    value: 'seller'
  }, {
    label: 'Because of an inheritance or transfer within the family',
    value: 'inheritance'
  }, {
    label: 'I just want to know the price development of my property. I don\'t want to sell',
    value: 'price-development'
  }, {
    label: 'I would like to conclude or renew my mortgage',
    value: 'mortgage'
  }, {
    label: 'I would like to buy a property',
    value: 'buyer'
  }, {
    label: 'Just out of curiosity',
    value: 'curiosity'
  }, {
    label: 'Other reason',
    value: 'other'
  }],
  userBuyer: [{
    label: 'I am a first time buyer',
    value: 'first-time-buyer'
  }, {
    label: 'I already own a property',
    value: 'owned-property'
  }],
  userSeller: [{
    label: 'As soon as possible',
    value: 'asap'
  }, {
    label: 'In a few months',
    value: 'few-months'
  }, {
    label: 'I don\'t want to sell now',
    value: 'no-sell'
  }],
  valueRelevantServitudeOptions: [{
    label: 'Yes',
    value: 1
  }, {
    label: 'No',
    value: 0
  }],
  yesNoOpt: [{
    label: 'Yes',
    value: true
  }, {
    label: 'No',
    value: false
  }],
  windows: [{
    label: 'Wood',
    value: 'wood',
    id: 'windowMaterialOptions.wood'
  }, {
    label: 'Aluminium',
    value: 'aluminium',
    id: 'windowMaterialOptions.aluminium'
  }, {
    label: 'Synthetics',
    value: 'synthetics',
    id: 'windowMaterialOptions.synthetics'
  }, {
    label: 'Double glazed windows',
    value: 'doubleGlazed',
    id: 'windowMaterialOptions.synthetics'
  }, {
    label: 'Other',
    value: 'other',
    id: 'windowMaterialOptions.other'
  }],
  windowsInsulationOptions: [{
    label: 'Yes',
    value: true,
    id: 'windowsInsulationOptions.yes'
  }, {
    label: 'No',
    value: false,
    id: 'windowsInsulationOptions.no'
  }]
};